import React, { useState, Fragment, useEffect } from "react";
import ReactHtmlParser from "react-html-parser";
const TRANSLATE_URL = process.env.REACT_APP_API_URL + "/google-translate";
export default function Translate({ input, lang }) { 
  const [text, setText] = useState(input);
  const [translationDone, setTranslationDone] = useState(false);
  useEffect(() => {      

    const req = fetch(TRANSLATE_URL, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        q: input,
        target: lang,
      }),
    });   

    req.then((m) => {
      m.json().then((k) => {
        setText(k.output);
      });
    });

    setTranslationDone(true);
  }, [input]);
  return <Fragment>{translationDone === true ? ReactHtmlParser(text) : ''}</Fragment>;
}
